/**
 * Check if the renter has paid the payer
 * @param {Object} tr - The transaction object
 * @param {String} tr.title - Transaction title
 * @param {Number} tr.amount - Total transaction amount
 * @param {Array<{payer: String, amount: Number}>} tr.payers - Array of payers and their amounts
 * @param {Object<String, Object<String, Number>>} tr.rentersCost - Object mapping renter to payer to cost amount
 * @param {Object<String, Object<String, Number>>} tr.rentersPaid - Object mapping renter to payer to paid amount
 * @param {String} tr.slipImageName - Name of the slip image file
 * @param {Date} tr.timestamp - Transaction timestamp
 * @param {String} renter - The renter name
 * @param {String} payer - The payer name
 * @returns {Boolean}
 */
export function isRenterPaid(tr, renter, payer) {
  return tr.rentersCost[renter][payer] <= tr.rentersPaid[renter][payer];
}

/**
 * Check if the renter has paid all the payers
 * @param {Object} tr - The transaction object
 * @param {String} tr.title - Transaction title
 * @param {Number} tr.amount - Total transaction amount
 * @param {Array<{payer: String, amount: Number}>} tr.payers - Array of payers and their amounts
 * @param {Object<String, Object<String, Number>>} tr.rentersCost - Object mapping renter to payer to cost amount
 * @param {Object<String, Object<String, Number>>} tr.rentersPaid - Object mapping renter to payer to paid amount
 * @param {String} tr.slipImageName - Name of the slip image file
 * @param {Date} tr.timestamp - Transaction timestamp
 * @param {String} renter - The renter name
 * @returns {Boolean}
 */
export function isRenterCompletePaid(tr, renter) {
  for (let payer in tr.rentersPaid[renter]) {
    if (!isRenterPaid(tr, renter, payer)) return false;
  }
  return true;
}